import { computed, ref } from 'vue'

type ModalState = boolean

export function useModalState<T>(
  options: { isOpen?: boolean, initialState?: T } = { }
) {
  const state = ref<T>(options.initialState as T)
  const isOpen = ref(options.isOpen ?? false)

  return {
    isOpen: computed(() => isOpen.value),
    state: computed(() => state.value as T),

    open(x?: T) {
      isOpen.value = true
      state.value = x as T
    },

    isClosed: computed(() => !isOpen.value),
    close() {
      isOpen.value = false
      state.value = options.initialState as T
    },
  }
}
